import { Box } from "@mui/material";
import AccountsSidebar from "./AccountsSidebar";
import { Outlet } from "react-router-dom";

const AccountsLayout = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      {/* Header */}
      <Box
        sx={{
          height: 64,
          bgcolor: "primary.main",
          color: "white",
          display: "flex",
          alignItems: "center",
          px: 3,
          fontWeight: "bold",
          fontSize: "18px",
          boxShadow: 3,
        }}
      >
        Accounts Management
      </Box>

      {/* Body: Sidebar + Content */}
      <Box sx={{ display: "flex", flex: 1, minHeight: 0 }}>
        {/* Sidebar */}
        <Box
          sx={{
            width: 260,
            bgcolor: "white",
            borderRight: "1px solid #e0e0e0",
            boxShadow: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <AccountsSidebar />
        </Box>

        {/* Main Content */}
        <Box
          sx={{
            flex: 1,
            bgcolor: "grey.50",
            p: 3,
            overflowY: "auto",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default AccountsLayout;
